import * as THREE from 'three';

import GameSceneRace from "@/GameSceneRace";


class Game {

	webGl: any;

	//camera: THREE.PerspectiveCamera;
	renderer: THREE.WebGLRenderer;
	scene: THREE.Scene;

///	controls: OrbitControls;

	width: any;
	height: any;

	aspectRatio: any;

	canvas: any;


	box: any;
	material: any;
	mesh: any;

	prevTime: number;

	gameScene: any;

	constructor(webGl: any, width: any, height: any) {
		console.log("game constructor, webGl = " + webGl);

		this.webGl = webGl;

		this.scene = null!;
///		this.controls = null!;
		this.renderer = null!;
		//this.camera = null!;

		this.box = null!;
		this.material = null!;
		this.mesh = null!;

		this.prevTime = Date.now();

//		this.setCanvas();

///		this.setViewSize(width, height);

		this.gameScene = null!;

		console.log("constructor, webGl = " + JSON.stringify(webGl));


	}

	setViewSize(width: any, height: any) {
		this.width = width;
		this.height = height;
		this.aspectRatio = width.value / height.value;
	}

/*
	setCanvas() {
		console.log("setCanvas");

		this.scene = new THREE.Scene();

		this.camera = new THREE.PerspectiveCamera(45, this.aspectRatio.value, 0.1, 100);
		this.camera.position.z = 30;
		this.scene.add(this.camera);

		this.canvas = this.webGl.value;
		this.renderer = new THREE.WebGLRenderer({ canvas: this.canvas, antialias: true });
		this.renderer.setSize(this.width, this.height);
		this.renderer.render(this.scene, this.camera);

		this.controls = new OrbitControls(this.camera, this.canvas);
		this.controls.enableDamping = true;
	}
*/


	updateCamera() {
		console.log("updateCamera");
		
		if (this.gameScene != null) {
			const camera = this.gameScene.getCamera();
			if (camera != null) {
				camera.aspect = this.aspectRatio;
///////		this.camera.updateProjectionMatrix();
			} 
		}
		
	}
	


	updateRenderer() {
		console.log("updateRenderer");
		this.renderer.setSize(this.width, this.height);
		
		if (this.gameScene != null) {
			const camera = this.gameScene.getCamera();
			if (camera != null) {
				this.renderer.render(this.scene, camera);
			}
		}
		
	}

	animate() {
      // mesh.rotation.y += 0.01;
		///console.log("animate, this.controls = " + this.controls);
///		this.controls.update();
		
		
		
		if (this.gameScene != null) {
			this.gameScene.animate();
		}

		requestAnimationFrame(() => this.animate());

		/*
		const dt : number = Date.now() - this.prevTime;
		this.prevTime = Date.now();

		if (this.box !== null) {
			this.box.rotateY(dt * 1 / 1000);
			this.box.rotateX(dt * 0.5 / 1000);
			this.box.rotateX(dt * 0.2 / 1000);
		}
		*/

		//this.renderer.render(this.scene, this.camera);

	}


	onMounted(webGl: any) {
		console.log("mounted, webGl = " + JSON.stringify(webGl));

		this.setViewSize(window.innerWidth, window.innerHeight);

		this.webGl = webGl;

		this.canvas = this.webGl.value;
//		this.canvas = this.webGl;
//this.canvas = document.getElementById("webGl") as HTMLCanvasElement;

		console.log("mounted, this.canvas = " + this.canvas);

		this.renderer = new THREE.WebGLRenderer({ canvas: this.canvas, powerPreference: "high-performance", 
			antialias: true, logarithmicDepthBuffer: true });
			
		this.renderer.toneMapping = THREE.ACESFilmicToneMapping;

		this.renderer.shadowMap.enabled = true;
		this.renderer.shadowMap.type = THREE.PCFShadowMap;
///		this.renderer.shadowMap.type = THREE.PCFSoftShadowMap;
        

		this.scene = new THREE.Scene();



/*
      // Lights
      const light = new THREE.PointLight(0xffffff, 1);
      // light = new HemisphereLight(0xffff, 0x080820, 1);
      light.position.set(50, 50, 50);
      this.scene.add(light);

      this.camera.add(light);
*/


		this.updateRenderer();

		this.updateCamera();
		

///		this.controls = new OrbitControls(this.camera, this.canvas);
///		this.controls.enableDamping = true;

///		console.log("onMounted before animate, this.controls = " + this.controls);

		this.animate();

///		console.log("onMounted after animate, this.controls = " + this.controls);



	}

	//setup() {
	//	console.log("setup");
	//}

	buttonClick(buttonId: string) {
		console.log("buttonClick, buttonId = " + buttonId);		

		let el: any;

		switch(buttonId) {
		case "button1":
			this.scene.background = new THREE.TextureLoader().load("/images/galaxy1.avif");

			// тестовый объект; потом всё это будет в отдельном классе или файле сцены
					
			//this.box = new THREE.BoxGeometry( 15, 15, 15 );
			this.box = new THREE.IcosahedronGeometry(0.2, 0);
			this.material = new THREE.MeshNormalMaterial();

			this.mesh = new THREE.Mesh( this.box, this.material );
			this.scene.add( this.mesh );

			console.log("buttonClick, создали кубик и т.п.");		

			break;

		case "level_infinity_world":
			console.log('buttonClick, инициализируем "Бесконечный мир"');		

			//this.scene.background = new THREE.TextureLoader().load("/images/galaxy1.avif");

			this.gameScene = new GameSceneRace(this.scene, this.webGl, this.renderer);
			break;

		case "change_camera":
			console.log("buttonClick, переключаем камеру");
			
			this.gameScene.changeCameraMode();

			break;
			
		case "change_car_show_mode":
			console.log("buttonClick, переключаем режим отображения машины");
			
			this.gameScene.changeCarShowMode();

			break;
				
		case "change_terrain_show_mode":
			console.log("buttonClick, переключаем режим отображения физической поверхности");
			
			this.gameScene.changeTerrainShowMode();

			break;
			
		case "change_auto_steering":
			el = document.getElementById("autoSteeringCheckbox");
			if (el != null) {
				const checked = !el.checked;
				
				this.gameScene.switchAutoSteering(checked);
				
			}
			
			
			break;	

		}


	}


}

export default Game;